import { Button, Dropdown, Field, Option } from "@fluentui/react-components";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import { useState, useEffect } from "react";
import "./style.css";
import { setDialogModalOptions } from "../../redux/modelDialogReducer";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import moment from "moment";
import ASCButton from "../../components/Button";
import DynamicDatePicker from "../../components/ControlledDatePicker/dynamicDatepicker";

interface PropsType {
  [x: string]: any;
}

const ActionListDateFilter = (props: PropsType) => {
  const options = [
    { label: "Define Dates", value: "defineDates" },
    { label: "All Dates", value: "allDates" },
    { label: "Past Dates", value: "pastDate" },
    {
      label: "Today Plus Overdue",
      value: "todayDateOverdue",
    },
    {
      label: "Next 7 Days Plus Overdue",
      value: "next7DaysOverdue",
    },
    {
      label: "Next 31 Days Plus Overdue",
      value: "next31DaysOverdue",
    },
    {
      label: "This Year Plus Overdue",
      value: "thisYearOverdue",
    },
  ];
  const [context, setContext] = useState<string>("");
  const [contextLabel, setContextLabel] = useState<string>(
    props.optionDateValue
  );
  const [startDate, setStartDate] = useState<any>("");
  const [endDate, setEndDate] = useState<any>("");
  const [optionDate, setOptionDate] = useState("");

  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {

    let newOption = `defineDates&start_date=${startDate !== "" ? moment(startDate).format("YYYY-MM-DD[T00:00:00.000Z]") : ""
      }&end_date=${endDate !== "" ? moment(endDate).format("YYYY-MM-DD[T00:00:00.000Z]") : ""
      }`;
    setOptionDate(newOption);
  }, [startDate, endDate]);

  function onDropDownList(e: any, data: any) {
    setContext(data.optionValue);
    setContextLabel(data.optionText);
    if (data.optionValue !== "defineDates") {
      setOptionDate(data.optionValue);
    }
  }

  // const onFormatDate = (date?: Date): string => {
  //   return `${date?.getMonth()}/${date?.getDate()}/${date?.getFullYear()}`;
  // };
  const onFormatDate = (date?: Date): string => {
    return !date ? "" : moment(date).format("DD-MM-YYYY");
  };

  return (
    <>
      <div className="date-filter-body">
        <Dropdown onOptionSelect={onDropDownList} value={contextLabel}>
          {options.map((option, index) => (
            <Option value={option.value} key={index}>
              {option.label}
            </Option>
          ))}
        </Dropdown>

        <div>
          <label style={{ color: "gray" }}>Choose a date range</label>
          <div style={{ display: "flex", gap: "10px" }}>
            <DynamicDatePicker
              label="Start Date"
              required={false}
              disabled={context !== "defineDates"}
              name="startDate"
              border
              formik={{
                values: {
                  startDate,
                },
                setFieldValue: (_name: string, value: any) => {
                  if (value) {
                    setStartDate(value);
                  }
                },
                setFieldTouched: () => { },
                setFieldError: () => { },
                errors: {},
                touched: {},
              }}
            />

            <DynamicDatePicker
              label="End Date"
              required={false}
              disabled={context !== "defineDates"}
              name="endDate"
              border
              formik={{
                values: {
                  endDate,
                },
                setFieldValue: (_name: string, value: any) => {
                  if (value) {
                    setEndDate(value);
                  }
                },
                setFieldTouched: () => { },
                setFieldError: () => { },
                errors: {},
                touched: {},
              }}
            />
          </div>
        </div>
      </div>

      <div className="flex_end">
        <ASCButton
          shape="rounded"
          onClick={() => {
            dispatch(setDialogModalOptions({ open: false }));
          }}
          label="Cancel"
        />
        <ASCButton
          shape="rounded"
          className="asc-button-primary"
          appearance="primary"
          onClick={() => {
            props.dateSelection(optionDate);
            props.dateLabel(contextLabel);
            dispatch(setDialogModalOptions({ open: false }));
          }}
          label="Select"
        />
      </div>
    </>
  );
};

export default ActionListDateFilter;
